import { Document } from './../../../models/Document';
import { post } from './../../../api/index';
import {
  GET_DOWNLOAD_DOCUMENT,
  GET_DOWNLOAD_TICKET_PDF,
  GET_EXERCISE_RESIGN,
  GET_USER_DOCUMENT,
  GET_USER_PASSES_URL,
} from "./../../../api/apiRoutes";
import { useCallback, useState } from "react";
import { GET_USER_SELECTS_URL } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";
import { Ticket } from "../../../models/Ticket";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import convertToPdf from "../../../../utils/convertToPdf";
import { errorMessageFromApi } from "../../../utils/apiErrorMessages";
import getId from "../../../../utils/getId";
import { useDispatch } from "react-redux";
import { setInfoMessage } from "../../../store/alerts/alertsActions";

export default function useMethodAccount(accountIds?: string) {
  const facilityIds = useFacility();
  const dispatch = useDispatch();
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [passes, setPasses] = useState<Ticket[]>([]);
  const [docs, setDocs] = useState<Document[]>([]);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState("");
  const { get } = useApiRequest();
  const [ticketsLoading, setTicketsLoading] = useState(false);

  const getSelect = useCallback(async () => {
    setTicketsLoading(true);
    const { result, isError } = await get(GET_USER_SELECTS_URL(facilityIds, accountIds));
    if (!isError) {
      setTickets(result);
    }
    setTicketsLoading(false);
  }, [get, facilityIds, accountIds]);

  const getLimited = useCallback(async () => {
    setTicketsLoading(true);
    const { result, isError } = await get(GET_USER_PASSES_URL(facilityIds, accountIds));
    if (!isError) {
      setPasses(result);
    }
    setTicketsLoading(false);
  }, [get, facilityIds, accountIds]);

  const resignExercise = async (exercise: any, onSuccess?: () => void) => {
    setAlert("");
    const exerciseIds = getId(exercise);
    const response = await post(GET_EXERCISE_RESIGN(exerciseIds, facilityIds));
    if (!response.isError) {
      dispatch(setInfoMessage(["Twoja rezerwacja została odwołana."]));
      onSuccess?.();
      return { ok: true, error: "" };
    }
    const error = errorMessageFromApi(response);
    setAlert(error);
    return { ok: false, error };
  };

  const getUserDocuments = async () => {
    const { result, isError } = await get(GET_USER_DOCUMENT(facilityIds));
    if (!isError) {
      setDocs(result);
    }
  };

  const getBoughtTickets = async (documentIds: string) => {
    setLoading(true);
    setAlert("");
    const params = {
      facilityIds: `0,${facilityIds}`,
      documentIds: documentIds,
    };
    const response = await get(GET_DOWNLOAD_TICKET_PDF(params));
    if (!response.isError) {
      const pdf = convertToPdf(response.result);
      window.open(URL.createObjectURL(pdf));
    } else {
      setAlert(errorMessageFromApi(response));
    }
    setLoading(false);
  };

  const getDownloadDocument = async (documentIds: string) => {
    setLoading(true);
    setAlert("");
    const params = {
      facilityIds: `0,${facilityIds}`,
      documentIds: documentIds,
    };
    const response = await get(GET_DOWNLOAD_DOCUMENT(params));
    if (!response.isError) {
      const pdf = convertToPdf(response.result);
      window.open(URL.createObjectURL(pdf));
    } else {
      setAlert(errorMessageFromApi(response));
    }
    setLoading(false);
  };

  return {
    alert,
    getUserDocuments,
    getBoughtTickets,
    getDownloadDocument,
    resignExercise,
    getLimited,
    passes,
    getSelect,
    tickets,
    docs,
    loading,
    ticketsLoading,
  };
}
